// Select.js
import { FieldWrapper } from "./field-wrapper";
import { Label } from "./label";
import { Error } from "./error";
import ReactSelect from "react-select";

export const Select = ({
  label,
  options,
  error,
  className,
  defaultValue,
  registration,
  readOnly,
}) => {
  return (
    <FieldWrapper label={label} error={error}>
      <select
        className={`form-select ${className || ""}`}
        defaultValue={defaultValue}
        disabled={readOnly}
        {...registration}
      >
        {options.map(({ label, value }) => (
          <option readOnly={readOnly} key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </FieldWrapper>
  );
};

export const RSelect = ({
  isClearable = false,
  isSearchable = true,
  className,
  error,
  label,
  ...props
}) => {
  return (
    <div className="w-100">
      <Label className="text-sm font-medium">{label}</Label>
      <ReactSelect
        isClearable={isClearable}
        isSearchable={isSearchable}
        menuPlacement="auto"
        minMenuHeight={300}
        {...props}
        styles={{
          control: provided => {
            let borderColor = provided.borderColor;
            let boxShadow = provided.boxShadow;

            if (error) {
              borderColor = "red";
              boxShadow = "0 0 0 1px red";
            }

            return {
              ...provided,
              borderColor,
              "&:hover": {
                boxShadow,
              },
            };
          },
          menuList: provided => ({
            ...provided,
            maxHeight: "180px",
            overflowY: "auto",
          }),
        }}
        theme={theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: error ? "red" : theme.colors.primary,
          },
        })}
      />
      <Error errorMessage={error?.message} />
    </div>
  );
};
